'use strict';
var $ = window.$;

let mediaXxs = 320;
let mediaXs = 480;
let mediaSm = 768;
let mediaMd = 1024;
let mediaLg = 1200;
let mediaXl = 1440;
let mediaXxl = 1600;
let mediaXxxl = 1920;

let localHash = window.location.hash;
window.location.hash = ""

$(document).ready(function () {

  $.fancybox.defaults.touch = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.autoFocus = false;

  $('[data-fancybox]').fancybox({
    mobile : {
      clickSlide: "close",
      clickOutside : 'close',
    }
  });

  // Открытие мобильного меню

  $('.js-open-menu').on('click', function(e){
    $(this).toggleClass('is-open');
    $('#mobile-menu').toggleClass('is-open');
    $('body').addClass('menu-open');
  });

  // закрытие мобильного меню
  $('.js-close-menu').on('click', function(e){
    $(this).removeClass('is-open');
    $('.js-open-menu').removeClass('is-open');
    $('#mobile-menu').removeClass('is-open');
    $('body').removeClass('menu-open');
  });

  // bottom-menu
  let lastScroll = 0;

  $(document).on('scroll load', function() {
    let $footer = $('.footer__bottom')
    let $position = $(window).scrollTop();
    if ($position > lastScroll) {
      $('#bottom-menu').addClass('is-shown');
      $footer.addClass('bottom-menu-is-active');
    } else {
      $('#bottom-menu').removeClass('is-shown');
      $footer.removeClass('bottom-menu-is-active');
    }
    lastScroll = $position;
  })

  // Якорная ссылка в начало страницы

  function anchorUp() {
    let $block = $('.anchor-up');

    $(document).on('scroll', function() {
      if ($(window).scrollTop() > 400) {
        $block.addClass('is-shown');
      } else {
        $block.removeClass('is-shown');
      }
    })
  }

  anchorUp()

  //  Плавный переход к якорю

	$('[js-anchor]').on("click touchend", function (event) {
      let target = $(this).attr('href');
      $('html, body').animate({
        scrollTop: 0
      }, 500);
      return true;
	});


  // dropdown

  $('[data-drop-next]').on('click', function(){
    $(this).toggleClass('is-open')
    $(this).siblings().slideToggle(200);
  });

  $('[data-drop-next-mobile]').on('click', function(){
    if ($(window).width() > 1279) {
      return false;
    } else {
      $(this).toggleClass('is-open')
      $(this).siblings().slideToggle(200);
    }
  });

  $('[data-drop-next-menu]').on('click', function(e){
    if (!$(e.target).is('a')) {
      $(this).toggleClass('is-open')
      $(this).siblings().slideToggle(200);
    }
  });

  // iframe

  $('[iframe-load]').on('click', function(e) {
    if (e.target.className == 'play') {
      const frame = e.target.nextElementSibling;
      const link = frame.dataset.src;
      const $img = $(this).find('img');
      const $button = $(this).find('.play');

      $(frame).attr('src', link);
      $(frame).removeAttr('data-src');
      $img.addClass('hide');
      $button.addClass('hide');
    }
  })

  // mask

  $('[inputmode="numeric"]').mask('+7 (999) 999-99-99',{autoclear: false,});

  // tabs

  $(document).delegate('[js-tabs] [data-button]', 'click', function(e){
    e.preventDefault();
    let $block = $(this).closest('[js-tabs]');
    let index = $(this).data('button');

    $('[data-button]', $block).parent().removeClass('is-active');
    $('[data-button=' + index + ']', $block).parent().addClass('is-active');
    $('[data-tab]', $block).removeClass('is-active');
    $('[data-tab=' + index + ']', $block).addClass('is-active');

    let $sliders = $('[data-tab=' + index + ']').find('.slick-slider');
    if($sliders.length) $sliders.slick('setPosition');

    if ($('[data-tab=' + index + '] .service-list[scroll-table]:not(._init-scroll)').length) {
      $('[data-tab=' + index + '] .service-list[scroll-table]:not(._init-scroll)').parent().trigger('update');
    }
  });


  $(document).on('click', '[js-active-toggle]',function() {
    $(this).toggleClass('is-active');
  })

  //



  $(document).on('click', '[js-sort]', function() {
    let $sort = $(this).find('[class*="_sorting"]');
    $sort.addClass('desc');
    $sort.toggleClass('asc');
  })

  $(document).on('click', '.js-sort', function(e) {
    e.preventDefault();
    let $sort = $(this);
    if (!$sort.hasClass('desk') && !$sort.hasClass('asc')) {
      $sort.addClass('desk')
    } else if ($sort.hasClass('desk')) {
      $sort.removeClass('desk');
      $sort.addClass('asc');
    } else {
      $sort.removeClass('asc');
    }
  })

  // number input

  $(document).on('click', '[number-input]', function(e) {
    let $input = $(this).find('[class*="__input"]');
    let $decreaseButton = $(this).find('[class*="_decrease"]');
    let $increaseButton = $(this).find('[class*="_increase"]');

    if ($(e.target).is($decreaseButton)) {
      $input.val(parseInt($input.val()) - 1);
      $input.trigger('input');
    }

    if ($(e.target).is($increaseButton)) {
      $input.val(parseInt($input.val()) + 1);
      $input.trigger('input');
    }

    if ($input.val() <= 0) {
      $input.val(0);
    }
  })

  const checkNumberInput = ($input) => {
    if (parseInt($input.val())>9999) $input.val(9999);
    if (parseInt($input.val()) < 0) $input.val(0);
    if ($input.parents('[scroll-table]').length) return;
    $input.css('min-width',`${$input.val().length*9}px`);
  }

  $('[number-input] input').each((_,item) => {
    checkNumberInput($(item))
  })

  $(document).on('input', '[number-input] input', function(e) {
    let $input = $(this);
    $input.val(parseInt($input.val()));
    checkNumberInput($input)
  })

  $(document).on('blur', '[number-input] input', function(e) {
    let $input = $(this);
    $input.val(parseInt($input.val()));
    checkNumberInput($input);
    if (isNaN(parseInt($input.val()))) {
      $input.val(1);
    }
  })

    // Показ пароля в инпуте
    $(document).on('click', '[js-password-input] [class*="__visibility-btn"]', function(){
      let $block = $(this).closest('[js-password-input]');
      let $input = $block.find('[class*="__input"]');
      if ($input.attr('type') == 'password') {
        $input.prop('type', 'text');
      } else {
        $input.prop('type', 'password');
      }
    })

  // scrollbar

  $('[data-scroll], .has-scrollbar-y').each(function() {
    let $list = $(this);

    new SimpleBar($list[0], {autoHide: false});
  });

  $('[data-scroll-2]').each(function() {
    let $list = $(this);

    new SimpleBar($list[0]);
  });

  // datepicker
  if ($('[datepicker]').length) {
    const startDay = $('[datepicker]').attr('data-start-day');
    const startMonth = $('[datepicker]').attr('data-start-month');
    const startYear = $('[datepicker]').attr('data-start-year');
    const startDateDatepicker = (startDay && startYear && startMonth)
        ? new Date($('[datepicker]').attr('data-start-year'), $('[datepicker]').attr('data-start-month'), $('[datepicker]').attr('data-start-day'))
        : new Date();

    $('[datepicker]').datepicker({
      startDate: startDateDatepicker,
      prevHtml: '<div class="my-datepicker__nav my-datepicker__nav_prev"></div>',
      nextHtml: '<div class="my-datepicker__nav my-datepicker__nav_next"></div>',
      autoClose: true,
      onRenderCell: function(date, cellType) {
        if (cellType == 'day' && date.getDate() == $('[datepicker]').attr('data-start-day') && date.getMonth() == $('[datepicker]').attr('data-start-month')) {
          return {
            classes: 'my-class'
          }
        }
      },
    });
  }

  function checkIsSlick(el) {
    if (el.hasClass('slick-initialized')) {
      el.slick('unslick');
    }
  };

  // sliders

  $('[banner-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      fade: true,
      cssEase: 'linear',
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      autoplay: true,
      autoplaySpeed: 5000,
      // speed: 800,
      // centerMode: true,
      // appendDots: $dots,
    });
	})

  $('[tab-service-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
    });
	})

  $('[webinar-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__roster"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: false,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 480 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1280 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
	})

  $('[news-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1440 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
	})

  $('[equipment-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
	})

  $('[knowledge-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 2,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 480 - 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768 - 1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024 - 1,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
      ],
    });
	})

  $('[product-slider]').each((_,item) => {
    const $item = $(item);
    if ($item.children().length > 1) {
      $item.slick({
        infinite: false,
        sliderToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        // autoplay: true,
        // autoplaySpeed: 5000,
        // speed: 800,
        // centerMode: true,
        // appendDots: $dots,
      });
    }
  })

  $('[news-main-slider]').each(function() {
		let $block = $(this);
		let $init = $block.find('[class*="__list"]');
    let $dots = $block.find('[class*="-dots"]');
		let $prev = $block.find('[class*="_prev"]');
		let $next = $block.find('[class*="_next"]');

    $init.slick({
      infinite: true,
      sliderToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: $dots,
      prevArrow: $prev,
      nextArrow: $next,
      // autoplay: true,
      // autoplaySpeed: 5000,
      // speed: 800,
      // centerMode: true,
      // appendDots: $dots,
    });
	})

  $('[slider-dots]').each(function() {
    let transformXIntervalNext = -28;
    let transformXIntervalPrev = 28;
    let maxDots = 5;
    let $block = $(this);
    let $init = $block.find('[class*="__roster"]');
    let $list = $block.find('ul.slick-dots');
    let $dots = $list.find('li');

    function setBoundries(slick, state) {
      if (state === 'default') {
        slick.find('ul.slick-dots li').eq(4).addClass('n-sm');
      }
    }
    let $wrap = "<div class='slick-dots-container' id='test'></div>"
    let $wrapList = $list.wrap($wrap).parent();
    $dots.each(function (index) {
      $(this).addClass('dot-index-' + index);
    })
    $list.css('transform', 'translateX(0)');
    setBoundries($block,'default');

    let transformCount = 0;
    $init.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      let totalCount = $dots.length;
      if (totalCount > maxDots) {
        if (nextSlide > currentSlide) {
          if ($block.find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-sm')) {
            if (!$block.find('ul.slick-dots li:last-child').hasClass('n-sm')) {
              transformCount = transformCount + transformXIntervalNext;
              $block.find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-sm');
              let nextSlidePlusOne = nextSlide + 1;
              $block.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-sm');
              $block.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
              let pPointer = nextSlide - 3;
              let pPointerMinusOne = pPointer - 1;
              $block.find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-sm');
              $block.find('ul.slick-dots li').eq(pPointer).addClass('p-sm');
            }
          }
        }
        else {
          if ($block.find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-sm')) {
            if (!$block.find('ul.slick-dots li:first-child').hasClass('p-sm')) {
              transformCount = transformCount + transformXIntervalPrev;
              $block.find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-sm');
              let nextSlidePlusOne = nextSlide - 1;
              $block.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-sm');
              $block.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
              let nPointer = currentSlide + 3;
              let nPointerMinusOne = nPointer - 1;
              $block.find('ul.slick-dots li').eq(nPointer).removeClass('n-sm');
              $block.find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-sm');
            }
          }
        }
      }
    });

    $init.on('breakpoint', function(event, slick, breakpoint) {
      $wrapList.remove();
    })
  })

  function changeBtnText(btn, width, mobileText, desktopText) {
    $(window).on('load resize', function() {
      let $windowWidth = $(window).width();
      if ($windowWidth > width) {
        btn.text(desktopText);
      } else {
        btn.text(mobileText);
      }
    })
  }

  $('[data-btn-text]').each(function() {
    changeBtnText($(this), 767, 'Сбросить', 'Сбросить фильтр')
  })

  $('[data-btn-text-1]').each(function() {
    changeBtnText($(this), 1279, 'Рассылка', 'Подпиcаться на рассылку')
  })

  $('[data-btn-text-2]').each(function() {
    changeBtnText($(this), 1279, 'Календарь', 'Календарь событий')
  })

  $('[data-search-btn]').each(function() {
    let $block = $(this);
    let $form = $('[data-search-form]');

    $block.on('click', function() {
      $form.show(400);
    })
  })

  $(document).on('click', '[data-search-close]', function(){
    $(this).closest('[data-search-form]').hide(400)
  })
  // mh_todo VB-405 добавил тротл
  let nav = priorityNav.init({
      mainNavWrapper: '[js-priority-navigation]',
      navDropdownLabel: 'Еще',
      throttleDelay: '150'
  });


  $('.js-valid').on('change', function (e) {
    $(this).val().length > 0 ? $(this).addClass('_valid') : $(this).removeClass('_valid');
  })

  $('[select-search]').each(function (index, item) {
      var $select = $(item);
      var $search = $select.find('[select-search-form] .input');
      var $list = $select.find('[data-inputs] li');


      $search.on('input', function () {
        var value = $(this).val().toLowerCase();
        var countHide = 0
        $select.width($select.width());//при поиске чтобы не прыгал
        $list.each(function (listIndex,listItem) {
          var $listItem = $(listItem);
          var name = $listItem.find('label').text().toLowerCase();
          if (name.indexOf(value)+1) $listItem.removeClass('_hide')
          else {
            countHide++;
            $listItem.addClass('_hide')
          }
        })
        countHide === $list.length ? $select.addClass('_is-empty'):$select.removeClass('_is-empty');
      })

    if ($select.find('[select-search-form] form').length) {
      $select.find('[select-search-form] form').on('submit', function (e) {
        e.preventDefault();
      })
    }
  })

  function initScrollTable() {
    const selector = ".service-list[scroll-table]:not(._init-scroll)";
      $(selector).each(function () {
        let $block = $(this);
        const $parent = $block.parent();
        let $headTable = $block.find('.service-list__head-wrap');
        let $scrollTable = $block.find('.service-list__roster');
        let isDesk = window.matchMedia(`(min-width:${mediaMd}px)`).matches;

        function widthColumns() {
          const maxWidthColumns = [];

          $headTable.find('.service-list__head-item .service-list__title').each(function (index, item) {
            maxWidthColumns.push($(item).outerWidth())
          })
          $scrollTable.find('.service-card__wrap').each(function (_, row) {
            $(row).find('.service-card__item').each(function (i,cell) {
              let maxWidth = 0;
              $(cell).find('>*').each(function (_,item) {
                maxWidth = maxWidth < $(item).outerWidth() ? $(item).outerWidth() : maxWidth;
              });
              maxWidthColumns[i] = maxWidthColumns[i] < maxWidth ? maxWidth : maxWidthColumns[i];
            });
          })

          maxWidthColumns.forEach(function (maxWidth, indexColumn) {
            const $headCell = $headTable.find(`.service-list__head-item:nth-child(${indexColumn+1})`);
            if ($headCell.width() > maxWidth) {
              $headCell.width(maxWidth);
              $scrollTable.find(`.service-card__item:nth-child(${indexColumn+1})`).width(maxWidth);
              // console.log($scrollTable.find(`.service-card__item:nth-child(${indexColumn+1})`));
            }
          })
        }

        function onScrollTable() {
          $parent.data('scrollX',$(this).scrollLeft());
          $parent.data('scrollY',$(this).scrollTop());
          $headTable.css('transform', `translateX(${-$(this).scrollLeft()}px)`);
        }

        function alignWidthNI() {
          let max = 0;
          const $inputs = $block.find('[number-input] input');
          if ($inputs.length === 0) return ;
          $inputs.each((_,input) => {
            max = $(input).val().length > max? $(input).val().length: max;
          });

          $inputs.css('min-width',`${max*9}px`);

          return max*9;
        }

        alignWidthNI();


        function updateScrollTable() {
          $block = $parent.children(selector);
          $headTable = $parent.find('.service-list__head-wrap');
          $scrollTable = $parent.find('.service-list__roster');

          $scrollTable.on('scroll', onScrollTable);
          alignWidthNI();

          if (isDesk && $parent.is(':visible')) {
            removeWidth();
            $block.addClass('_init-scroll');
            widthColumns();
          }

          $scrollTable.scrollTop($parent.data('scrollY')? $parent.data('scrollY'): 0);
          $scrollTable.scrollLeft($parent.data('scrollX')? $parent.data('scrollX'): 0);
          $(window).on('resize', onResize);
        }

        function onResize() {
          const nowMedia = window.matchMedia(`(min-width:${mediaMd}px)`).matches
          if (nowMedia && nowMedia !== isDesk) {
            isDesk = nowMedia;
            updateScrollTable();
          } else if (!nowMedia && nowMedia !== isDesk) {
            isDesk = nowMedia;
            removeWidth();
          }
        }
        function removeWidth() {
          $block.removeClass('_init-scroll');
          $headTable.find('.service-list__head-item').css('width','');
          $scrollTable.find(`.service-card__item`).css('width','');
        }
        $parent.on('update', updateScrollTable);
        //mh_todo VB-296 при сортировке и добавлении у родителя вызвать .trigger('update');


        if (!$parent.is(':visible')) {
          return;
        }
        if (isDesk) {
          widthColumns();
        }
        $block.addClass('_init-scroll');
        $scrollTable.on('scroll', onScrollTable);

        $block.on('input', '[number-input] input', (e) => {
          const $input = $(e.currentTarget);
          $input.val(parseInt($input.val()));
          if (parseInt($input.val())>9999) $input.val(9999);
          if (parseInt($input.val()) <= 0) $input.val(0);
          alignWidthNI();
        })

        $(window).on('resize', onResize);
      });
  }
  initScrollTable();

  $(document).on('mouseenter touchstart','[js-hover-link] a',(e) => {
    $(e.currentTarget).parents('[js-hover-link]').addClass('is-hover-link')
  })
  $(document).on('mouseleave touchend','[js-hover-link] a',(e) => {
    $(e.currentTarget).parents('[js-hover-link]').removeClass('is-hover-link')
  })

  $('.js-side-menu').each((_,item)=> {
    const $sideMenu = $(item);
    const $openMenu = $sideMenu.find('[data-drop-next]');

    $openMenu.each((_,link) => {
      if ($(link).parent().hasClass('is-active')) {
        $(link).addClass('is-open')
      }
    })
  })


  $('[data-js-input-file-drag]').each((_,item) => {
    const $container = $(item);
    const $drag = $container.find('label');
    const $input = $drag.find('input[type="file"]')
    const $filename = $container.find('.js-file-name');

    $input.on('focus', () => {
      $drag.addClass('focus')
    })

    const outputFile = (files) => {
      $filename.addClass('active').text(files[0].name);
    }

    $input.on('focusout', () => {
      $drag.removeClass('focus')
    })

    $drag.on('drag dragstart dragend dragover dragenter dragleave drop', function(){
      return false;
    });

    $drag.on('dragover dragenter', function() {
      $drag.addClass('focus');
    });

    $drag.on('dragleave', function(e) {
      let dx = e.pageX - $drag.offset().left;
      let dy = e.pageY - $drag.offset().top;
      if ((dx < 0) || (dx > $drag.width()) || (dy < 0) || (dy > $drag.height())) {
        $drag.removeClass('focus');
      };
    });

    $drag.on('drop', function(e) {
      $drag.removeClass('focus');
      let files = e.originalEvent.dataTransfer.files;
      $input.get(0).files = files;
      outputFile(files)
    });

    $input.on('change', () => {
      const files = $input.get(0).files;
      outputFile(files)
    })
  })


  window.EventsInit = (vectorEvents, otherEvents) => {
    const $calendar = $('#calendar');
    let params = (new URL(document.location)).searchParams;
    let startDay = (params.get('month') !== null && params.get('year') !== null) ? new Date(params.get('year'), params.get('month') - 1, 1) : new Date()

    const months = {1: 'января', 2: 'февраля', 3: 'марта', 4: 'апреля', 5: 'мая', 6: 'июня', 7: 'июля', 8: 'августа', 9: 'сентября', 10: 'октября', 11: 'ноября', 12: 'декабря', };

    function renderDays(date, cellType) {
      var currentDate = date.getDate();
      const currentYear = date.getFullYear();
      var currentMonth = date.getMonth() + 1
      const $link = $(`<a href="#calendar-modal" onclick="window.EventsOpen(event)" data-fancybox="" data-year="${currentYear}" data-date="${currentDate}" data-month="${currentMonth}" class="calendar-link"></a>`)
      const $container = $('<div></div>').append($link);


      if(cellType == 'day'
          && otherEvents.hasOwnProperty(currentYear)
          && otherEvents[currentYear].hasOwnProperty(currentMonth)
          && otherEvents[currentYear][currentMonth].hasOwnProperty(currentDate)
          && vectorEvents.hasOwnProperty(currentYear)
          && vectorEvents[currentYear].hasOwnProperty(currentMonth)
          && vectorEvents[currentYear][currentMonth].hasOwnProperty(currentDate)
      )
      {
        $link.append('<span class="calendar-link__event calendar-link__event_vector"></span>' +
            '<span class="calendar-link__event calendar-link__event_other"></span>')
        return {
          html: currentDate + $container.html(),
          classes: 'events'
        };
      }

      if(cellType == 'day'
          && vectorEvents.hasOwnProperty(currentYear)
          && vectorEvents[currentYear].hasOwnProperty(currentMonth)
          && vectorEvents[currentYear][currentMonth].hasOwnProperty(currentDate)
      )
      {
        $link.append('<span class="calendar-link__event calendar-link__event_vector">')
        return {
          html: currentDate + $container.html(),
          classes: 'events'
        };
      }

      if(cellType == 'day'
          && otherEvents.hasOwnProperty(currentYear)
          && otherEvents[currentYear].hasOwnProperty(currentMonth)
          && otherEvents[currentYear][currentMonth].hasOwnProperty(currentDate)
      )
      {
        $link.append('<span class="calendar-link__event calendar-link__event_other"></span>')
        return {
          html: currentDate + $container.html(),
          classes: 'events'
        };
      }
    }

    function renderMonthCalendar(date) {
      const monthText = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
      const $month = $('<div></div>');
      $month.datepicker({
        startDate: date,
        view: 'days',
        showOtherMonths: false,
        selectOtherMonths: false,
        moveToOtherMonthsOnSelect: false,
        showOtherYears: false,
        selectOtherYears: false,
        onRenderCell: renderDays
      });
      $month.prepend("<div class='datepicker-header-title' onclick='window.EventsToMonth(event)' data-month='"+date+"'>"+monthText[date.getMonth()]+"</div>")
      return {
        html: $month.html(),
        classes: 'min_calendar',
        disabled: true,
      }
    }

    window.EventsToMonth = function (e) {
      const date = $(e.currentTarget).data('month');
      const datepicker = $calendar.data('datepicker');
      const offsetTop = $calendar.offset().top;
      if (datepicker) {
        datepicker.view = 'days';
        datepicker.date = new Date(date);
        if (offsetTop < $(window).scrollTop()) {
          $(window).scrollTop($calendar.offset().top)
        }
      }
    }

    window.EventsOpen = function (e) {
      e.stopPropagation();
      let currentDate = $(e.currentTarget).data('date');
      let currentMonth = $(e.currentTarget).data('month');
      let currentYear = $(e.currentTarget).data('year');
      let listItems = '';
      let item;

      if(vectorEvents.hasOwnProperty(currentYear)
          && vectorEvents[currentYear].hasOwnProperty(currentMonth)
          && vectorEvents[currentYear][currentMonth].hasOwnProperty(currentDate))
      {
        for(let i in vectorEvents[currentYear][currentMonth][currentDate])
        {
          item = vectorEvents[currentYear][currentMonth][currentDate][i];
          listItems += `
						<div class="modal-event__item">
						<div class="modal-event__text">
							<p>${item.city},</p>
							<p>${item.name}</p>
						</div>
					</div>
					`;
        }
      }
      if(otherEvents.hasOwnProperty(currentYear)
          && otherEvents[currentYear].hasOwnProperty(currentMonth)
          && otherEvents[currentYear][currentMonth].hasOwnProperty(currentDate))
      {
        for(let i in otherEvents[currentYear][currentMonth][currentDate])
        {
          item = otherEvents[currentYear][currentMonth][currentDate][i];
          listItems += `
						<div class="modal-event__item">
                          <div class="modal-event__text">
                              <p>${item.city},</p>
                              <p>${item.name}</p>
                              
                          </div>
					    </div>
					`;
        }
      }

      $('#calendar-modal .modal__title').text(currentDate + ' ' + months[currentMonth]);
      $('#calendarModalContent').html(listItems);
      $.fancybox.open({
        src:'#calendar-modal'
      })
    }

    function initEvents() {
      $calendar.datepicker({
        numberOfMonths: [4, 3],
        stepMonths:12,
        view: "months",
        onChangeMonth: function(month, year){
          // window.history.replaceState(null, null, '?month=' + (month + 1) +'&year=' + year);
          window.location.href = window.location.origin + window.location.pathname + '?month=' + (month + 1) +'&year=' + year;
        },
        onRenderCell: function onRenderCell(date, cellType){
          if (cellType === 'day') return renderDays(date, cellType)
          if (cellType === 'month') return renderMonthCalendar(date);
        }
      });
    }

    initEvents();
  }


  $(document).on('mouseenter', '.js-tooltip', (e) => {
    const $target = $(e.target);
    const $drop = $target.siblings('.tooltip-def');
    const positionTarget = $target.offset();
    const positionDrop = {
      top: positionTarget.top - $drop.outerHeight() - 10 - $(window).scrollTop(),
      left: (positionTarget.left + $target.outerWidth() / 2) - ($drop.outerWidth() / 2),
    }

    if ((positionDrop.left + $drop.outerWidth()) > $(window).width()) {
      positionDrop.left = $(window).width() - $drop.outerWidth();
    }

    if (positionDrop.left < 0) {
      positionDrop.left = 0;
    }

    $drop.css({
      top: positionDrop.top,
      left: positionDrop.left
    })
        .addClass('is-active');
  })

  $(document).on('mouseleave', '.js-tooltip', (e) => {
    const $target = $(e.target);
    const $drop = $target.siblings('.tooltip-def');

    $drop.removeClass('is-active');
    setTimeout(() => {
      $drop.attr('style', '');
    },300)
  })

  function wrapScrollTable ($table) {
    console.log($table);
    $table.wrap('<div class="wrap-table"></div>');
    setTimeout(() => {
      new SimpleBar($table.parent()[0], {autoHide: false});
    },300)
  }

  $('.js-adaptive-table').each((_, item) => {
    const $table = $(item).find('table');
    $table.each((_,item) => wrapScrollTable($(item)));
  })

  if (localHash) {
    const $hashElem = $(localHash);

    if ($hashElem && $hashElem.parents('.service-list').length) {
      const $headService = $('.service-list__head');
      let scrollTop = $hashElem.offset().top + 'px';

      if (window.matchMedia('(min-width: 1024px)').matches) {
        scrollTop = ($hashElem.offset().top - $headService.outerHeight() ) + 'px'
      }

      setTimeout(function() {
        $('html, body').animate({
          scrollTop
        },400, () => {
          $hashElem.addClass('animate-back');
        })
        window.scrollTo(0, 0);
      }, 0);
    }
    else {
      window.location.hash = localHash;
    }
  }

  // фикс высоты на мобилке с учетом нижней плашки
  function vhResizeHack() {
    const onResize = () =>
        $('html').css('--vh', `${window.innerHeight * 0.01}px`);

    $(window).on('resize', onResize);
    onResize();
  };
  vhResizeHack();
});
